<template>
	<div class="p-grid p-flex-column p-m-0 p-p-4 container p-jc-center p-ai-center">
		<div class="p-col-12 p-text-center">
			<h1 class="p-component view-title">{{ $t('Squeeze.Login.SQUEEZE') }}</h1>
			<h2 v-if="statusKey === '403'" class="p-component">{{ $t('ErrorPage.403.Label', { position: $t('ErrorPage.Position.Document')}) }}</h2>
			<h2 v-else class="p-component">{{ $t('ErrorPage.' + statusKey + '.Label') }}</h2>
		</div>
	</div>
</template>

<script lang="ts">
import {computed, defineComponent, onMounted} from "vue";
import {useRoute} from "vue-router";
import {useI18n} from "vue-i18n";

/** Status shown when route.query.status is missing or has no translation */
const FALLBACK_STATUS = '404';

export default defineComponent({
	name: 'ErrorPage',
	components: {},
	props: {
		apps: {
			type: Array,
		},
	},
	setup() {
		const { locale, te } = useI18n({ useScope: 'global' });
		const route = useRoute();

		/**
		 * The status the error message is built from. Never pass route.query.status into the i18n key
		 * unchecked: vue-i18n renders the raw key when no translation exists, so any unexpected value
		 * ends up on screen as "ErrorPage.<whatever>.Label" (see bug 18186).
		 */
		const statusKey = computed(() => {
			const status = Array.isArray(route.query.status) ? route.query.status[0] : route.query.status;
			return status && te('ErrorPage.' + status + '.Label') ? String(status) : FALLBACK_STATUS;
		});

		onMounted(() => {
			// check current language
			if (localStorage.getItem('language')) {
				locale.value = localStorage.getItem('language')!;
			}
		})

		return { statusKey }
	},
});
</script>

<style scoped lang="scss">

.container {
	min-height: 100vh;
}

h1,h2 {
	&.view-title {
		color: var(--dex-primary-color);
		margin: 0 0 2rem;
	}
}

h1.view-title {
	font-size: 4rem;
}

h2 {
	font-size: 2rem;
}

</style>
